const getCommercialCategories = (serverCommercialCategories)=>{
    var _key, _name, _key1, _name1;
    return serverCommercialCategories.map((category)=>({
            key: (_key = category.key) !== null && _key !== void 0 ? _key : undefined,
            name: (_name = category.name) !== null && _name !== void 0 ? _name : undefined,
            ancestors: category.ancestors.map((ancestor)=>({
                    key: (_key1 = ancestor.key) !== null && _key1 !== void 0 ? _key1 : undefined,
                    name: (_name1 = ancestor.name) !== null && _name1 !== void 0 ? _name1 : undefined
                })
            )
        })
    );
};

export { getCommercialCategories };
//# sourceMappingURL=get-commercial-categories.js.map
